import React from 'react';
import { applyStyles, isSP } from 'util/helpers';
import Image from 'components/common/Image';
import i18n from 'i18n';
import Tag from 'components/common/Tag';
import Button from 'components/common/Button';
import SelectField from 'components/common/SelectField';
import DatepickerField from 'components/common/DatepickerField';
import ConfirmDialog from 'components/OrderAggregators/components/ConfirmDialog';
import MessageCardDialog from 'components/OrderAggregators/components/MessageCardDialog';
import ReceiverDialog from 'components/OrderAggregators/components/ReceiverDialog';
import ShipperDialog from 'components/OrderAggregators/components/ShipperDialog';
import WrappingInfoDialog from 'components/OrderAggregators/components/WrappingInfoDialog';
import Tooltip from './Tooltip';
import { get } from 'lodash';
import icBtnUpPC1x from 'assets/images/PC/@1x/ic_btn_up.png';
import icBtnUpPC2x from 'assets/images/PC/@2x/ic_btn_up@2x.png';
import icBtnUpSP2x from 'assets/images/SP/@2x/ic_btn_up@2x.png';
import icBtnUpSP3x from 'assets/images/SP/@3x/ic_btn_up@3x.png';
import icBtnDownPC1x from 'assets/images/PC/@1x/ic_btn_down.png';
import icBtnDownPC2x from 'assets/images/PC/@2x/ic_btn_down@2x.png';
import icBtnDownSP2x from 'assets/images/SP/@2x/ic_btn_down@2x.png';
import icBtnDownSP3x from 'assets/images/SP/@3x/ic_btn_down@3x.png';
import icDatePC1x from 'assets/images/PC/@1x/ic_date.png';
import icDatePC2x from 'assets/images/PC/@2x/ic_date@2x.png';
import icDateSP2x from 'assets/images/SP/@2x/ic_date@2x.png';
import icDateSP3x from 'assets/images/SP/@3x/ic_date@3x.png';
import {
  commonStyle,
  pcStyle,
  spStyle
} from 'components/OrderAggregators/styles/order';
import {
  getAddressInfo,
  renderAddressOneLine,
  renderAddressMultipleLines,
  renderWrappingInfo,
  renderWrappingInfoDetail,
  renderMessageCardInfo,
  handleWrappingInfoDialogSave,
  handleMessageCardDialogSave,
  updateReferringData,
  handleValidatedOnChange,
  referringDataTemplate,
  isInvalidReceiverValues,
  isInvalidShipperValues
} from 'components/OrderAggregators/scripts/order';
import ReferredOrderSelect from 'components/OrderAggregators/components/ReferredOrderSelect';
import { required } from 'validation/validators';
import MessageCardType from 'constants/message-card-type';

class Order extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: true
    };
    this.wrappingInfoDialogRef = React.createRef();
    this.messageCardDialogRef = React.createRef();
    this.receiverDialogRef = React.createRef();
    this.shipperDialogRef = React.createRef();
    this.confirmDialogRef = React.createRef();
    this.purchaseNumOptions = Array.from(
      Array(+process.env.REACT_APP_ORDER_PURCHASE_ITEMS_NUM_MAX)
    ).map((_, i) => i + 1);
  }

  componentDidMount() {
    // コピーした注文の場合、スクロールするように
    if (this.getFormValues().referringOrderInfo.checked) {
      const headerHeight = isSP() ? 55 : 103;
      const topScrollHeight = document
        .getElementById(`order-${this.props.index}`)
        .getBoundingClientRect().top;
      window.scroll({
        top: topScrollHeight + window.pageYOffset - headerHeight,
        behavior: 'smooth'
      });
    }
  }

  getFormValues() {
    return get(this.props.getState().values, this.props.fieldName);
  }

  handleClickToggle() {
    this.setState({
      opened: !this.state.opened
    });
  }

  handleClickDelete(index, formValues) {
    if (this.existsReferringOrders(index, formValues)) {
      this.props.releaseReferringOrders(index - 1);
    }
    this.props.remove(index - 1);
  }

  createAlertMessage(index, formValues) {
    return {
      title:
        i18n.t('orderAggregators:common:order.order') +
        index +
        i18n.t('orderAggregators:common:order.alertDeleteOrderTitle'),
      message:
        i18n.t('orderAggregators:common:order.alertDeleteOrder') +
        (this.existsReferringOrders(index, formValues)
          ? i18n.t('orderAggregators:common:order.alertReleaseReferrings')
          : '')
    };
  }

  existsReferringOrders(index, formValues) {
    return (
      !formValues.referringOrderInfo.checked &&
      this.props.existsReferringOrders(index - 1)
    );
  }

  handleReceiverDialogSave(receiverValues) {
    const { fieldName, change } = this.props;
    change(`${fieldName}.receiver`, receiverValues);
    updateReferringData(this.props);
  }

  handleShipperDialogSave(shipperValues) {
    const { fieldName, change } = this.props;
    change(`${fieldName}.shipper`, shipperValues);
    updateReferringData(this.props);
  }

  render() {
    const {
      className,
      index,
      fieldName,
      datepickerMin,
      datepickerMax,
      fetchAddress,
      updateOrder,
      referredOrderOptions,
      copyable,
      copyOrder,
      releaseReferringOrders,
      updateReferringOrders,
      orders,
      change
    } = this.props;

    const formValues = this.getFormValues();

    if (formValues == null) {
      return null;
    }

    return (
      <div id={`order-${index}`} className={className}>
        <div className="header-panel">
          <button
            type="button"
            className="btn-toggle"
            onClick={() => this.handleClickToggle()}
          >
            {this.state.opened ? (
              <Image
                pc1x={icBtnUpPC1x}
                pc2x={icBtnUpPC2x}
                sp2x={icBtnUpSP2x}
                sp3x={icBtnUpSP3x}
                alt="ic_btn_up"
              />
            ) : (
              <Image
                pc1x={icBtnDownPC1x}
                pc2x={icBtnDownPC2x}
                sp2x={icBtnDownSP2x}
                sp3x={icBtnDownSP3x}
                alt="ic_btn_down"
              />
            )}
          </button>
          <h2>{`${i18n.t('orderAggregators:common:order.order')}${index}`}</h2>
          {index === 1 && (
            <div className="notice">{i18n.t('orderAggregators:common:order.notice1')}<br />{i18n.t('orderAggregators:common:order.notice2')}</div>
          )}
          {index > 1 && (
            <Button
              buttonType="G-delete"
              type="button"
              className="header-btn btn-delete"
              onClick={() => this.confirmDialogRef.current.open()}
            >
              {i18n.t('common:delete')}
            </Button>
          )}
        </div>
        <div className={`order-content ${this.state.opened ? '' : 'close'}`}>
          <table>
            <tbody>
              <tr className="row-thick">
                <th>
                  <span className="required-cell-wrapper">
                    {i18n.t('orderAggregators:common:order.orderCount')}
                    <Tag>{i18n.t('common:required')}</Tag>
                  </span>
                </th>
                <td>
                  <SelectField
                    options={this.purchaseNumOptions}
                    name={`${fieldName}.purchaseItem.num`}
                  />
                  <span className="notification">
                    {i18n.t('orderAggregators:purchase:orderCountNotification')}
                  </span>
                </td>
              </tr>
              <tr className="row-variable">
                <th>
                  <span className="required-cell-wrapper">
                    {i18n.t('orderAggregators:common:order.validityPeriod')}
                    <Tag>{i18n.t('common:required')}</Tag>
                  </span>
                </th>
                <td>
                  <div className="validity-period">
                    <DatepickerField
                      onChange={val => handleValidatedOnChange(this.props, val, false)}
                      name={`${fieldName}.purchaseItem.validatedOn`}
                      minDate={datepickerMin.format(
                        i18n.t('common:dateFormat.default')
                      )}
                      maxDate={datepickerMax.format(
                        i18n.t('common:dateFormat.default')
                      )}
                      validate={value => required(value)}
                    />
                    <div className="expired-end">
                      <Image
                        className="expire-from-to"
                        pc1x={icDatePC1x}
                        pc2x={icDatePC2x}
                        sp2x={icDateSP2x}
                        sp3x={icDateSP3x}
                        alt="ic_date"
                      />
                      <DatepickerField
                        name={`${fieldName}.purchaseItem.expiredOn`}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <span className="notification">
                    {i18n.t(
                      'orderAggregators:purchase:validityPeriodNotification'
                    )}
                  </span>
                </td>
              </tr>
              <tr>
                <th>{i18n.t('orderAggregators:common:order.wrappingInfo')}</th>
                <td
                  className="has-dialog"
                  onClick={() => this.wrappingInfoDialogRef.current.open()}
                >
                  <div className="cell-wrapper">
                    <span className="value ellipsis">
                      {renderWrappingInfo(formValues.wrappingInfo)}
                    </span>
                    <Button
                      className="G-edit"
                      buttonType="G-edit"
                      type="button"
                    >
                      {i18n.t('common:edit')}
                    </Button>
                  </div>
                  {formValues.wrappingInfo.wrappingType !==
                    i18n.t(
                      'orderAggregators:common:order.wrappingType1Name'
                    ) && (
                    <Tooltip>
                      {renderWrappingInfoDetail(formValues.wrappingInfo)}
                    </Tooltip>
                  )}
                </td>
              </tr>
              <tr>
                <th>{i18n.t('orderAggregators:common:order.messageCard')}</th>
                <td
                  className="has-dialog"
                  onClick={() => this.messageCardDialogRef.current.open()}
                >
                  <div className="cell-wrapper">
                    <span className="value ellipsis">
                      {renderMessageCardInfo(formValues.wrappingInfo, true)}
                    </span>
                    <Button
                      className="G-edit"
                      buttonType="G-edit"
                      type="button"
                    >
                      {i18n.t('common:edit')}
                    </Button>
                  </div>
                  {!!formValues.wrappingInfo.messageCard &&
                    formValues.wrappingInfo.messageCardType ===
                      MessageCardType.input && (
                      <Tooltip>{formValues.wrappingInfo.messageCard}</Tooltip>
                    )}
                </td>
              </tr>
              {index > 1 && (
                <tr key={index}>
                  <td colSpan="2">
                    <ReferredOrderSelect
                      name={`${fieldName}.referringOrderInfo`}
                      options={referredOrderOptions}
                      index={index}
                      formValues={formValues}
                      updateOrder={updateOrder}
                      releaseReferringOrders={releaseReferringOrders}
                      updateReferringOrders={updateReferringOrders}
                      change={change}
                    />
                  </td>
                </tr>
              )}
              <tr>
                <th>
                  <span className="required-cell-wrapper">
                    {i18n.t('orderAggregators:common:order.receiver')}
                    <Tag>{i18n.t('common:required')}</Tag>
                  </span>
                </th>
                <td
                  className="has-dialog"
                  onClick={() =>
                    !formValues.referringOrderInfo.checked &&
                    this.receiverDialogRef.current.open()
                  }
                >
                  <div className="cell-wrapper">
                    <span
                      className={`value ellipsis ${
                        getAddressInfo(formValues.receiver) != null
                          ? ''
                          : 'empty'
                      }`}
                    >
                      {renderAddressOneLine(formValues.receiver)}
                    </span>
                    {formValues.referringOrderInfo.checked ? (
                      !isInvalidReceiverValues(this.props) && (
                        <Button
                          className="G-confirm"
                          buttonType="G-confirm"
                          type="button"
                          onClick={() => this.receiverDialogRef.current.open()}
                        >
                          {i18n.t('common:confirm')}
                        </Button>
                      )
                    ) : (
                      <Button
                        className="G-edit"
                        buttonType="G-edit"
                        type="button"
                        onClick={() => this.receiverDialogRef.current.open()}
                      >
                        {i18n.t('common:edit')}
                      </Button>
                    )}
                  </div>
                  {getAddressInfo(formValues.receiver) != null && (
                    <Tooltip>
                      {renderAddressMultipleLines(formValues.receiver)}
                    </Tooltip>
                  )}
                </td>
              </tr>
              <tr>
                <th>
                  <span className="required-cell-wrapper">
                    {i18n.t('orderAggregators:common:order.from')}
                    <Tag>{i18n.t('common:required')}</Tag>
                  </span>
                </th>
                <td
                  className="has-dialog"
                  onClick={() =>
                    !formValues.referringOrderInfo.checked &&
                    this.shipperDialogRef.current.open()
                  }
                >
                  <div className="cell-wrapper">
                    <span
                      className={`value ellipsis ${
                        getAddressInfo(formValues.shipper) != null
                          ? ''
                          : 'empty'
                      }`}
                    >
                      {renderAddressOneLine(formValues.shipper)}
                    </span>
                    {formValues.referringOrderInfo.checked ? (
                      !isInvalidShipperValues(this.props) && (
                        <Button
                          className="G-confirm"
                          buttonType="G-confirm"
                          type="button"
                          onClick={() => this.shipperDialogRef.current.open()}
                        >
                          {i18n.t('common:confirm')}
                        </Button>
                      )
                    ) : (
                      <Button
                        className="G-edit"
                        buttonType="G-edit"
                        type="button"
                        onClick={() => this.shipperDialogRef.current.open()}
                      >
                        {i18n.t('common:edit')}
                      </Button>
                    )}
                  </div>
                  {getAddressInfo(formValues.shipper) != null && (
                    <Tooltip>
                      {renderAddressMultipleLines(formValues.shipper)}
                    </Tooltip>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          <div className="order-footer">
            <Button
              type="button"
              buttonType="F"
              disabled={!copyable}
              onClick={() => copyOrder(index - 1, formValues)}
            >
              {i18n.t('orderAggregators:purchase:duplicateOrder')}
            </Button>
          </div>
        </div>
        <WrappingInfoDialog
          dialogRef={this.wrappingInfoDialogRef}
          onSubmit={v => handleWrappingInfoDialogSave(this.props, v, false)}
          initialValues={{
            wrappingType: formValues.wrappingInfo.wrappingType,
            inscription: formValues.wrappingInfo.inscription,
            shipperName: formValues.wrappingInfo.shipperName,
            inscriptionType: formValues.wrappingInfo.inscriptionType,
            shipperNameType: formValues.wrappingInfo.shipperNameType
          }}
        />
        <MessageCardDialog
          dialogRef={this.messageCardDialogRef}
          onSubmit={v => handleMessageCardDialogSave(this.props, v, false)}
          initialValues={{
            messageCard: formValues.wrappingInfo.messageCard,
            messageCardType: formValues.wrappingInfo.messageCardType
          }}
        />
        <ReceiverDialog
          dialogRef={this.receiverDialogRef}
          onSubmit={v => this.handleReceiverDialogSave(v)}
          initialValues={formValues.receiver}
          fetchAddress={fetchAddress}
          referringDataTemplate={() =>
            referringDataTemplate(formValues.receiver)
          }
          isConfirm={formValues.referringOrderInfo.checked}
        />
        <ShipperDialog
          dialogRef={this.shipperDialogRef}
          onSubmit={v => this.handleShipperDialogSave(v)}
          initialValues={formValues.shipper}
          fetchAddress={fetchAddress}
          referringDataTemplate={() =>
            referringDataTemplate(formValues.shipper, 'shipper')
          }
          isInvalidReceiverValues={() => isInvalidReceiverValues(this.props)}
          isConfirm={formValues.referringOrderInfo.checked}
          orders={orders}
          index={index - 1}
          options={referredOrderOptions}
        />
        <ConfirmDialog
          innerRef={this.confirmDialogRef}
          onSubmit={() => this.handleClickDelete(index, formValues)}
          {...this.createAlertMessage(index, formValues)}
        />
      </div>
    );
  }
}

export default applyStyles(Order)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Purchase/components/Order.js